export const AWARD_TYPE_OPTIONS = [
  {
    label: 'Primary',
    value: 'primary',
  },
  {
    label: 'Backup',
    value: 'backup',
  },
  {
    label: 'Published',
    value: 'published',
  },
]

export const EQUIPMENT_TYPE_OPTIONS = [
  {
    label: "53' Van",
    value: '53_van',
  },
  {
    label: "53' Reefer",
    value: '53_reefer',
  },
  {
    label: "48' Flatbed",
    value: '48_flatbed',
  },
]

// Equipment types supported for True Rates
export const TRUE_RATE_EQUIPMENT_TYPE_OPTIONS = [
  {
    label: "53' Van",
    value: '53_van',
  },
  {
    label: "53' Reefer",
    value: '53_reefer',
  },
]

export const RATE_TYPE_OPTIONS = [
  {
    label: 'RPM',
    value: 'contract_rpm',
  },
  {
    label: 'Linehaul',
    value: 'contract_linehaul',
  },
  {
    label: 'All-in',
    value: 'contract_all_in',
  },
]

export const VOLUME_TYPE_OPTIONS = [
  {
    label: 'Gross',
    value: 'gross',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
  },
  {
    label: 'Annual',
    value: 'annual',
  },
]

export const DROP_TYPE_OPTIONS = [
  {
    label: 'Live',
    value: 'false',
  },
  {
    label: 'Drop',
    value: 'true',
  },
]

export enum SHIPPER_RATE_STATUS {
  ALL = 'all',
  ACTIVE = 'active',
  UPCOMING = 'upcoming',
  INACTIVE = 'inactive',
}
